import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Canvas } from '@react-three/fiber'
import { PerspectiveCamera, OrbitControls } from '@react-three/drei'

import { Floor } from './items/Floor'
import { ItemComponent } from './ItemComponent'
import { RestaurantContext } from '../../../RestaurantDesignerHandler'
import { RangeInput } from 'components/RangeInput/RangeInput'
import { saveToLocalStorage } from 'sections/statistics/utils'
import { REST_DESIGNER_POLAR_ANGLE } from './helpers'
import { RangeInputContainer } from './styled'

export const ThirdView = () => {
	const cameraRef = useRef()
	const controlsRef = useRef()
	const roomData = useContext(RestaurantContext).currentProjectData.roomData

	const [polarPosition, setPolarPosition] = useState(Math.PI / 3)
	const [isPolarEnabled, setIsPolarEnabled] = useState(false)

	const minPolarAngle = useMemo(() => {
		if (isPolarEnabled) {
			return 0
		}
		return polarPosition
	}, [isPolarEnabled, polarPosition])

	const maxPolarAngle = useMemo(() => {
		if (isPolarEnabled) {
			return Math.PI / 2 - 0.1
		}
		return polarPosition
	}, [isPolarEnabled, polarPosition])

	useEffect(() => {
		const previousPolarPosition = localStorage.getItem(REST_DESIGNER_POLAR_ANGLE)
		setPolarPosition(() => {
			if (previousPolarPosition) {
				return Number(previousPolarPosition)
			} return Math.PI / 3
		})
	}, [])

	return (
		<>
			<RangeInputContainer
				onMouseDown={() => setIsPolarEnabled(true)}
				onMouseUp={() => {
					setTimeout(() => { // a small timeout so the rotation animation can be finished
						const polarAngle = controlsRef.current.getPolarAngle()
						saveToLocalStorage(REST_DESIGNER_POLAR_ANGLE, polarAngle)
						setPolarPosition(polarAngle)
						setIsPolarEnabled(false)
					}, 1500)
				}}
			>
				<RangeInput
					id='cameraAngle'
					value={polarPosition * -1}
					min={Math.PI / -2 + 0.1}
					max={0}
					step={0.01}
					onChange={(newValue) => controlsRef.current.setPolarAngle(newValue * -1)}
				/>
			</RangeInputContainer>
			<Canvas
				dpr={[1, 2]}
				style={{
					height: '500px'
				}}
				shadows
			>
				<ambientLight intensity={0.1} />
				<directionalLight
					position={[50, 100, 50]}
					shadow-camera-top={5000}
					shadow-camera-bottom={-5000}
					shadow-camera-right={5000}
					shadow-camera-left={-5000}
					castShadow={true}
					intensity={0.3}
					shadow-mapSize={[200_000, 200_000]}
					shadow-camera-near={0.5}
  					shadow-camera-far={5000}
				/>

				<Floor color={roomData.roomColor} />
				{roomData.furniture?.map((element) => {
					return <ItemComponent element={element} roomColor={roomData.roomColor} />
				})}

				<OrbitControls
					ref={controlsRef}
					enableZoom={false}
					enablePan={false}
					target={[-640, 0, -450]}
					minPolarAngle={minPolarAngle}
					maxPolarAngle={maxPolarAngle}
					autoRotateSpeed={5}
				/>
				<PerspectiveCamera
					ref={cameraRef}
					makeDefault
					// position={[250, 250, 0]}
					position={[-640, 400, -1400]}
					fov={60}
					near={0.1}
					far={2500}
				/>
			</Canvas>
		</>
	)
}
